import { createContext } from 'react';

type HeaderInfoProps = {
  headerInfo: HeaderInfo;
  setHeaderInfo: (headerInfo: HeaderInfo) => void;
};

type HeaderInfo = {
  title: string;
  backPageUrl?: string;
  editable?: boolean;
  onBackButtonAction?: () => void;
};

const HeaderInfoContext = createContext<HeaderInfoProps>({
  headerInfo: {
    title: '',
    backPageUrl: undefined,
    editable: false,
    onBackButtonAction: undefined,
  },
  setHeaderInfo: () => undefined,
});

export { HeaderInfoContext };
export type { HeaderInfoProps, HeaderInfo };
